<template>
  <div>
    <PendingApprovalDetail :request="license" />
  </div>
</template>

<script>
import PendingApprovalDetail from '../components/pending/PendingApprovalDetail'

export default {
  props: ['license'],
  components: {
    PendingApprovalDetail
  },
  created() {
    if(!this.license){
      this.$router.push({
        name: "licenses"
      });
    }
  }
}
</script>

<style <style lang="scss" scoped>

</style>